var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header position-relative" }, [
        _c("h5", [_vm._v("Запросы")]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "position-absolute btn btn-outline-success",
            on: { click: _vm.getRecords },
          },
          [_vm._v("Обновить запросы")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: { loading: _vm.loading, color: _vm.loadingColor },
          }),
          _vm._v(" "),
          _c("div", [_c("Chat", { ref: "chat" })], 1),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.$currentRole === "admin" || _vm.$currentUID === 91
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [_c("TelegramMessageSender")],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }